
import { RouteObject, Navigate } from 'react-router-dom';
import ProtectedRoute from '../components/feature/ProtectedRoute';

// Direct imports - NO lazy loading
import LoginPage from '../pages/login/page';
import Dashboard from '../pages/dashboard/page';
import EmployeeDashboard from '../pages/employee-dashboard/page';
import EmployeeDashboardPHRetention from '../pages/employee-dashboard-PH-Retention/page';
import MTDSales from '../pages/mtd-sales/page';
import TodaysSales from '../pages/todays-sales/page';
import RetentionMTD from '../pages/retention-mtd/page';
import RetentionToday from '../pages/retention-today/page';
import PhilippinesSales from '../pages/philippines-sales/page';
import PhilippinesSalesToday from '../pages/philippines-sales-today/page';
import USPayroll from '../pages/us-payroll/page';
import Referrals from '../pages/referrals/page';
import SuggestionsAdmin from '../pages/suggestions-admin/page';
import TVView from '../pages/tv-view/page';
import ResetPassword from '../pages/reset-password/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/login" replace />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/reset-password',
    element: <ResetPassword />,
  },
  {
    path: '/dashboard',
    element: <ProtectedRoute requiredRole={['admin', 'employee']}><Dashboard /></ProtectedRoute>,
  },
  {
    path: '/employee-dashboard',
    element: <ProtectedRoute requiredRole={['admin', 'employee', 'ph_retention', 'ph_sales']}><EmployeeDashboard /></ProtectedRoute>,
  },
  {
    path: '/employee-dashboard-PH-Retention',
    element: <ProtectedRoute requiredRole={['admin', 'ph_retention']}><EmployeeDashboardPHRetention /></ProtectedRoute>,
  },
  {
    path: '/mtd-sales',
    element: <ProtectedRoute requiredRole={['admin', 'employee', 'ph_sales']}><MTDSales /></ProtectedRoute>,
  },
  {
    path: '/todays-sales',
    element: <ProtectedRoute requiredRole={['admin', 'employee', 'ph_sales']}><TodaysSales /></ProtectedRoute>,
  },
  {
    path: '/retention-mtd',
    element: <ProtectedRoute requiredRole={['admin', 'employee', 'ph_retention']}><RetentionMTD /></ProtectedRoute>,
  },
  {
    path: '/retention-today',
    element: <ProtectedRoute requiredRole={['admin', 'employee', 'ph_retention']}><RetentionToday /></ProtectedRoute>,
  },
  {
    path: '/philippines-sales',
    element: <ProtectedRoute requiredRole={['admin', 'employee', 'ph_sales']}><PhilippinesSales /></ProtectedRoute>,
  },
  {
    path: '/philippines-sales-today',
    element: <ProtectedRoute requiredRole={['admin', 'employee', 'ph_sales']}><PhilippinesSalesToday /></ProtectedRoute>,
  },
  {
    path: '/us-payroll',
    element: <ProtectedRoute requiredRole={['admin']}><USPayroll /></ProtectedRoute>,
  },
  {
    path: '/referrals',
    element: <ProtectedRoute requiredRole={['admin', 'employee']}><Referrals /></ProtectedRoute>,
  },
  {
    path: '/suggestions-admin',
    element: <ProtectedRoute requiredRole={['admin']}><SuggestionsAdmin /></ProtectedRoute>,
  },
  {
    path: '/tv-view',
    element: <ProtectedRoute requiredRole={['admin', 'employee']}><TVView /></ProtectedRoute>,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
